import React from 'react';
import {GameBadgeComponent} from '../game-badge/game-badge.component';
import {GameImageComponent, GameIconAnimationState} from '../game-image/game-image.component';
import {observer} from 'mobx-react';
import {TapHandler} from '../../../../tap-handler/tap-handler.component';
import {AnyStyledComponent} from 'styled-components';
import {GameInfo} from '../../../../../services/games/game-info';
import {GAME_IMAGE_CONTAINER} from '../../../css-constants';
import {OrbitComponentWithState} from '../../../../base-components/orbit-component-with-state/orbit-component-with-state';

interface GameImageContainerComponentState {
  isLoading: boolean;
}

export interface GameGameImageContainerComponentProps {
    gameInfo: GameInfo;
    box: AnyStyledComponent;
    playRealGameButton: React.ReactNode | null;
    onOpenRealGame: () => void;
    useSquareIcons?: boolean;
    onAnimationIconStateChange?(state: GameIconAnimationState): void;
}


@observer
export class GameImageContainerComponent extends OrbitComponentWithState<GameGameImageContainerComponentProps, GameImageContainerComponentState> {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true
    };
  }

  private _handleImageDoneLoading = () => {
    this.setState({ isLoading: false });
  }

  render() {
    //className="game-item-image"
    const gameItemImageRef: any = React.createRef();
    const Box = this.props.box;

    return (
      <TapHandler enabled={this.props.gameInfo.allowTap} elementRef={gameItemImageRef}>
        <Box className={`cy-game-image-container ${GAME_IMAGE_CONTAINER}`}
             ref={gameItemImageRef}
             onClick={this.props.onOpenRealGame}
             isLoading={this.state.isLoading}
             squareIcon={this.services.games.shouldUseSquareIcons(this.props.useSquareIcons)}
             isCasinoGameIcon={this.props.gameInfo.gameCategory === "card-and-table"}
        >
          <GameImageComponent
            gameInfo={this.props.gameInfo} useSquareIcons={this.props.useSquareIcons} onSettled={this._handleImageDoneLoading}
            onAnimationIconStateChange={this.props.onAnimationIconStateChange}
          />
          {this.props.playRealGameButton}
          <GameBadgeComponent badgeUrl={this.props.gameInfo.badgeUrl || undefined} squareIcon={this.props.useSquareIcons} />
        </Box>
      </TapHandler>);
  }
}
